/**
 * @author AgentStore
 * @description 登录、获取用户信息、退出登录、清除accessToken逻辑，不建议修改
 */
import {getUserInfo, login, logout, getGoogleAuthInfo, switchCurrIdentity} from '@/api/user'
import { startHeartbeat, stopHeartbeat, showUserIdentityChangedDialog } from '@/utils/heartBeat'
import { switchTheme } from '@/utils/theme'
import i18n, { setLocale, setI18nLanguage } from '@/locales/i18n'
import getPageTitle from '@/utils/pageTitle'
import { ElMessageBox } from 'element-plus'

import {deepClone} from '@/utils/index'
import websocket from '@/utils/websocket'
import {
  getAccessToken,
  removeAccessToken,
  removeToken,
  setAccessToken,
  setToken,
  getToken
} from '@/utils/accessToken'

const TEAM_CONTEXT_SWITCH_DELAY = 3000
let teamContextNoticeActive = false
let teamContextSwitching = false

const state = () => ({
  user_id: null,
  accessToken: getAccessToken(),
  user_name: '',
  nick_name: '',
  real_name: '',
  email: '',
  phone: '',
  avatar: '',
  token: getToken(),
  current_team_id: 0,
  current_team: {},
  current_team_ver: {},
  has_roles: [],
  roles: [],
  app_role: [],
  user_point: 0,
  user_sub: '',
  userNotificationChannel: null // 用户通知频道
})

const getters = {
  user_id: (state) => state.user_id,
  accessToken: (state) => state.accessToken,
  user_name: (state) => state.user_name,
  nick_name: (state) => state.nick_name,
  real_name: (state) => state.real_name,
  email: (state) => state.email,
  avatar: (state) => state.avatar,
  has_roles: (state) => state.has_roles,
  roles: (state) => state.roles,
  app_role: (state) => state.app_role,
  phone: (state) => state.phone,
  current_team_id: (state) => state.current_team_id,
  current_team: (state) => state.current_team,
  current_team_ver: (state) => state.current_team_ver,
  user_point: (state) => state.user_point,
  token: (state) => state.token,
  user_sub: (state) => state.user_sub
}

const mutations = {

  /**
   * @author AgentStore
   * @description 设置用户id
   * @param {*} state
   * @param {*} user_id
   */
  setUserId(state, user_id) {
    state.user_id = user_id
  },
  /**
   * @author AgentStore
   * @description 设置token
   * @param {*} state
   * @param {*} accessToken
   */
  setAccessToken(state, accessToken) {
    state.accessToken = accessToken
    setAccessToken(accessToken)
  },
  /**
   * @author AgentStore
   * @description 设置user_name
   * @param {*} state
   * @param {*} user_name
   */
  setUserName(state, user_name) {
    state.user_name = user_name
  },
  /**
   * @author AgentStore
   * @description 设置real_name
   * @param {*} state
   * @param {*} real_name
   */
  setRealName(state, real_name) {
    state.real_name = real_name
  },
  /**
   * @author AgentStore
   * @description 设置nick_name
   * @param {*} state
   * @param {*} nick_name
   */
  setNickName(state, nick_name) {
    state.nick_name = nick_name
  },
  /**
   * @author AgentStore
   * @description 设置nick_name
   * @param {*} state
   * @param {*} phone
   */
  setPhone(state, phone) {
    state.phone = phone
  },
  /**
   * @author AgentStore
   * @description 设置avatar
   * @param {*} state
   * @param {*} avatar
   */
  setAvatar(state, avatar) {
    state.avatar = avatar
  },
  /**
   * @author AgentStore
   * @description 设置has_roles
   * @param {*} state
   * @param {*} has_roles
   */
  setHasRoles(state, has_roles) {
    state.has_roles = has_roles
  },
  /**
   * @author AgentStore
   * @description 设置roles
   * @param {*} state
   * @param {*} roles
   */
  setRoles(state, roles) {
    state.roles = roles
  },
  /**
   * @author AgentStore
   * @description 设置app_role
   * @param {*} state
   * @param {*} app_role
   */
  setAppRole(state, app_role) {
    state.app_role = app_role
  },
  /**
   * @author AgentStore
   * @description 设置current_team_id
   * @param {*} state
   * @param {*} current_team_id
   */
  setCurrentTeamId(state, current_team_id) {
    state.current_team_id = current_team_id
  },
  /**
   * @author AgentStore
   * @description 设置current_team
   * @param {*} state
   * @param {*} current_team
   */
  setCurrentTeam(state, current_team) {
    state.current_team = current_team
  },
  setCurrentTeamVer(state, current_team_ver) {
    state.current_team_ver = current_team_ver || {}
  },
  /**
   * @author AgentStore
   * @description 设置邮箱
   * @param {*} state
   * @param {*} email
   */
  setEmail(state, email) {
    state.email = email
  },
  /**
     * @author AgentStore
     * @description 设置用户积分
     * @param {*} state
     * @param {*} point
     */
  setUserPoint(state, point) {
    state.user_point = point
  },
  setToken(state, token) {
    state.token = token
    setToken(token)
  },
  /**
     * @author AgentStore
     * @description 设置用户订阅
     * @param {*} state
     * @param {*} user_sub
     */
  setUserSub(state, user_sub) {
    state.user_sub = user_sub
  },
  resetUserState(state) {
    Object.assign(state, {
      user_id: null,
      accessToken: '',
      user_name: '',
      nick_name: '',
      real_name: '',
      email: '',
      phone: '',
      avatar: '',
      token: '',
      current_team_id: 0,
      current_team: {},
      current_team_ver: {},
      has_roles: [],
      roles: [],
      app_role: [],
      user_point: 0,
      user_sub: '',
      userNotificationChannel: null
    })
  }
}
const actions = {

  /**
   * @author AgentStore
   * @description 获取用户信息接口 这个接口非常非常重要，如果没有明确底层前逻辑禁止修改此方法，错误的修改可能造成整个框架无法正常使用
   * @param {*} { commit, dispatch, state }
   * @returns
   */
  async getUserInfo({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      getUserInfo()
        .then(async(response) => {
          const {data} = response
          const user = data.user
          if (!data) {
            dispatch('resetAll')
            reject({message: '验证失败，请重新登录...'})
          }
          if (!user.app_role || user.app_role.length === 0) {
            dispatch('resetAll')
            reject({message: '你没有权限！'})
          }
          commit('setAppRole', user.app_role)
          if (!user.has_roles) {
            dispatch('resetAll')
            reject({message: '你没有权限！'})
          }
          const hasRolesData = user.has_roles || []
          commit('setHasRoles', hasRolesData)
          const rolesData = []
          deepClone(hasRolesData, rolesData)
          if (rolesData.length === 0) {
            dispatch('resetAll')
            reject({message: '你没有权限！'})
          }
          commit('setRoles', rolesData)
          const useId = user.id
          const current_team_id = user.current_team_id
          const current_team = user.current_team
          const current_team_ver = user.current_team_ver || {}
          const user_name = user.user_name
          const real_name = user.real_name
          const phone = user.phone
          const avatar = user.avatar ? user.avatar : ''
          const nick_name = user.nick_name ? user.nick_name : (user.phone ? user.phone : user.email)
          const email = user.email
          const token = user.token
          const numericalAuth = current_team_ver.numerical_auth || {}
          const pointsQuota = numericalAuth.points_quota || numericalAuth
          const point = Number(pointsQuota.points_quota_surplus_numerical) || 0
          const preference = user.preference // 获取用户偏好设置
          const user_sub = current_team_ver.key || ''

          commit('setUserId', useId)
          commit('setUserName', user_name)
          commit('setRealName', real_name)
          commit('setPhone', phone)
          commit('setNickName', nick_name)
          commit('setAvatar', avatar)
          commit('setCurrentTeamId', current_team_id)
          commit('setCurrentTeam', current_team)
          commit('setCurrentTeamVer', current_team_ver)
          commit('setEmail', email)
          commit('setUserPoint', point)
          commit('setToken', token)
          commit('setUserSub', user_sub)

          // 清除过期的文档缓存
          dispatch('cleanExpiredDocCaches')
          dispatch('startUserHeartbeat')
          // 应用用户偏好设置（主题和语言）
          if (preference) {
            await dispatch('applyUserPreferences', preference)
          }

          resolve(user)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  /**
   * @author AgentStore
   * @description 登录
   * @param {*} { commit }
   * @param {*} userInfo
   */
  login({commit}, userInfo) {
    return new Promise((resolve, reject) => {
      const params = {}
      params.user_name = userInfo.user_name.trim()
      params.password = userInfo.password ? userInfo.password.trim() : ''
      params.valid_code = userInfo.valid_code ? userInfo.valid_code.trim() : ''
      params.login_type = userInfo.login_type ? userInfo.login_type : 0
      params.real_name = userInfo.real_name ? userInfo.real_name : ''
      if (userInfo.invite_code) {
        params.invite_code = userInfo.invite_code
      }
      login(params).then(response => {
        if (response.data && response.data.token) {
          const accessToken = response.data.token
          commit('setAccessToken', accessToken)
          resolve(true)
        } else {
          // ElMessage.error(`登录接口异常，未正确返回api_token...`)
          resolve(false)
        }
      }).catch(error => {
        console.log('error')
        reject(error)
      })
    })
  },
  googleLogin({commit}, paramsData) {
    return new Promise((resolve, reject) => {
      const params = {}
      params.google_code = paramsData.google_code
      if (paramsData.invite_code) {
        params.invite_code = paramsData.invite_code
      }

      getGoogleAuthInfo(params).then(response => {
        if (response.data && response.data.token) {
          const accessToken = response.data.token
          commit('setAccessToken', accessToken)
          resolve(true)
        } else {
          // ElMessage.error(`登录接口异常，未正确返回api_token...`)
          resolve(false)
        }
      }).catch(error => {
        console.log('error')
        reject(error)
      })
    })
  },

  /**
   * @author AgentStore
   * @description 退出登录
   * @param {*} { dispatch }
   */
  async logout({dispatch}) {
    websocket.close()
    try {
      if (getAccessToken()) {
        await logout()
      }
    } catch (error) {
      console.warn('服务端退出登录失败，已清理本地登录状态:', error)
    } finally {
      await dispatch('resetAll')
      localStorage.clear()
    }
  },
  async fedLogOut({dispatch}) {
    await dispatch('resetAll')
    localStorage.clear()
  },
  /**
   * @author AgentStore
   * @description 重置accessToken、roles、ability、router等
   * @param {*} { commit, dispatch }
   */
  async resetAll({commit, dispatch}) {
    teamContextNoticeActive = false
    teamContextSwitching = false
    // 停止心跳检测
    await dispatch('stopUserHeartbeat')
    await dispatch('stopUserNotificationSubscribe')
    websocket.close()
    removeAccessToken()
    removeToken()
    commit('resetUserState')
    await dispatch('team/reset', null, { root: true })
  },
  /**
   * @author AgentStore
   * @description 设置token
   */
  setAccessToken({commit}, accessToken) {
    commit('setAccessToken', accessToken)
  },
  /**
   * @author AgentStore
   * @description 设置roles
   */
  setRoles({commit}, accessToken) {
    commit('setRoles', accessToken)
  },
  /**
   * @author AgentStore
   * @description 设置has_roles
   */
  setHasRoles({commit}, accessToken) {
    commit('setHasRoles', accessToken)
  },
  /**
   * @author AgentStore
   * @description 设置app_roles
   */
  setAppRole({commit}, accessToken) {
    commit('setAppRole', accessToken)
  },
  /**
   * @author AgentStore
   * @description 设置用户积分
   */
  setUserPoint({commit}, point) {
    commit('setUserPoint', point)
  },
  /**
   * @author AgentStore
   * @description 启动用户心跳检测
   * @ state }
   */
  startUserHeartbeat() {
    startHeartbeat()
  },
  /**
   * @author AgentStore
   * @description 停止用户心跳检测
   * @param
   */
  stopUserHeartbeat({ commit }) {
    stopHeartbeat()
  },

  /**
   * @author AgentStore
   * @description 清除过期的文档缓存
   */
  cleanExpiredDocCaches() {
    try {
      const expireTime = 24 * 60 * 60 * 1000 // 1天过期时间
      const now = Date.now()

      // 遍历所有 localStorage 项
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i)
        if (key && key.startsWith('doc_cache_')) {
          try {
            const cacheStr = localStorage.getItem(key)
            if (cacheStr) {
              const cacheData = JSON.parse(cacheStr)
              // 检查是否过期
              if (cacheData.timestamp && (now - cacheData.timestamp > expireTime)) {
                localStorage.removeItem(key)
                console.log(`清除过期文档缓存: ${key}`)
              }
            }
          } catch (error) {
            // 数据格式错误，也清除
            localStorage.removeItem(key)
            console.log(`清除格式错误的文档缓存: ${key}`)
          }
        }
      }
    } catch (error) {
      console.error('清除过期文档缓存时发生错误:', error)
    }
  },

  /**
   * @author AgentStore
   * @description 启动用户通知订阅
   */
  startUserNotificationSubscribe({ state, dispatch }) {
    // 基础检查
    if (!state.accessToken) {
      console.log('用户未登录，跳过通知订阅')
      return
    }

    // 清理现有订阅
    if (state.userNotificationChannel) {
      try {
        state.userNotificationChannel.unsubscribe()
        state.userNotificationChannel = null
      } catch (error) {
        console.error('取消之前的订阅失败:', error)
      }
    }

    const userChannel = websocket.newUserNotificationSubscribe(state.token)
    if (!userChannel) {
      console.error('创建用户通知订阅失败')
      return
    }

    // 设置事件监听
    userChannel.on('error', (ctx) => {
      console.error('用户通知频道订阅错误:', ctx)
      state.userNotificationChannel = null
    })

    userChannel.subscribe()
    state.userNotificationChannel = userChannel
  },

  /**
   * @author AgentStore
   * @description 停止用户通知订阅
   */
  stopUserNotificationSubscribe({ state }) {
    if (state.userNotificationChannel) {
      try {
        state.userNotificationChannel.unsubscribe()
        state.userNotificationChannel = null
        console.log('用户通知频道订阅已停止')
      } catch (error) {
        console.error('停止用户通知订阅失败:', error)
      }
    }
  },

  /**
   * @author AgentStore
   * @description 处理用户通知
   */
  async handleUserNotification({ dispatch }, notificationData) {
    const { type} = notificationData

    switch (type) {
      case 'UB:user_logout':
        // 处理用户退出通知
        await dispatch('handleLogoutNotification')
        break
      case 'UB:team_disbanded':
      case 'UB:team_membership_lost':
        await dispatch('handleTeamContextSwitchNotification', notificationData)
        break
      default:
    }
  },

  /**
   * 当前团队失效后，提示用户并在三秒内强制切回个人团队。
   */
  async handleTeamContextSwitchNotification({ state }, notificationData) {
    const invalidTeamId = Number(notificationData && notificationData.team_id)
    const personalTeamId = Number(notificationData && notificationData.personal_team_id)
    if (!invalidTeamId || !personalTeamId ||
        invalidTeamId !== Number(state.current_team_id) || teamContextNoticeActive) {
      return
    }

    teamContextNoticeActive = true
    const isMembershipLost = notificationData.type === 'UB:team_membership_lost'
    const noticeKey = isMembershipLost
      ? 'common.team_membership_lost_switch_notice'
      : 'common.team_disbanded_switch_notice'
    let forceSwitchTimer = null
    const switchToPersonalTeam = async(instance = null) => {
      if (teamContextSwitching) return
      teamContextSwitching = true
      if (forceSwitchTimer) {
        clearTimeout(forceSwitchTimer)
        forceSwitchTimer = null
      }
      if (instance) instance.confirmButtonLoading = true

      try {
        const switchResponse = await switchCurrIdentity({ current_team_id: personalTeamId })
        if (!switchResponse || ![0, 200].includes(Number(switchResponse.code))) return
        window.location.href = '/'
      } catch (error) {
        console.error('团队上下文失效后切换个人团队失败:', error)
      } finally {
        teamContextSwitching = false
        if (instance) instance.confirmButtonLoading = false
      }
    }

    forceSwitchTimer = setTimeout(() => {
      switchToPersonalTeam()
    }, TEAM_CONTEXT_SWITCH_DELAY)

    ElMessageBox.alert(
      i18n.global.t(noticeKey),
      i18n.global.t('common.tips'),
      {
        confirmButtonText: i18n.global.t('common.confirm'),
        type: 'warning',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        beforeClose: (action, instance) => {
          if (action === 'confirm') switchToPersonalTeam(instance)
        }
      }
    ).catch(() => {})
  },

  /**
   * @author AgentStore
   * @description 处理退出登录通知
   */
  async handleLogoutNotification() {
    try {
      // 显示退出登录弹窗
      await showUserIdentityChangedDialog()
    } catch (error) {
      console.error('处理退出登录通知失败:', error)
    }
  },

  /**
   * @author AgentStore
   * @description 应用用户偏好设置（主题和语言）
   * @param {Object} preference 用户偏好设置对象
   */
  async applyUserPreferences({ commit }, preference) {
    try {
      const { theme_id, theme_key, language_key } = preference

      // 应用主题
      if (theme_id && theme_key) {
        switchTheme(theme_key)
      }

      // 应用语言
      if (language_key) {
        await setLocale(i18n, language_key)
        setI18nLanguage(i18n, language_key)
        document.title = getPageTitle()
      }
    } catch (error) {
      console.error('应用用户偏好设置失败:', error)
    }
  }
}
export default {namespaced: true, state, getters, mutations, actions}
